/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const BarChartThreeFillIcon = /*#__PURE__*/ createSvgIcon(
  'BarChartThreeFillIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M6 12.4H2V18h4v-5.6zM18 2h-4v16h4V2zM12 8H8v10h4V8z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default BarChartThreeFillIcon;
